import React, { useState } from "react";
import CommitOnBlurNumberInput from "../CommitOnBlurNumberInput";
import StaticValueInput from "./StaticValueInput";

const WORLD_LABEL_SCALE_MIN = 0.1;
const WORLD_IMAGE_SCALE_DISPLAY_RANGE = { min: 10, max: 300 };
const DEFAULT_WORLD_IMAGE_SCALE = 1;
const DEFAULT_WORLD_IMAGE_POSITION = "below";
const WORLD_IMAGE_POSITIONS = ["below", "above", "left", "right"];
const DEFAULT_WORLD_LABEL_SCALE = 10;

function getWorldImageScale(style = {}) {
  const imageScale = Number(style.imageScale);
  return !isNaN(imageScale) && imageScale > 0 ? imageScale : DEFAULT_WORLD_IMAGE_SCALE;
}

function getWorldLabelScale(scale) {
  const labelScale = Number(scale);
  return !isNaN(labelScale) && labelScale > 0 ? labelScale : DEFAULT_WORLD_LABEL_SCALE;
}

function getWorldImagePosition(style = {}) {
  return WORLD_IMAGE_POSITIONS.includes(style.imagePosition) ? style.imagePosition : DEFAULT_WORLD_IMAGE_POSITION;
}

function WorldLabelPositionScalePanel(props) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div
        className="EditorDrawerItemHeader"
        onClick={() => setOpen(!open)}
      >
        <span className="PanelOpenStatus">{open ? "▾" : "▸"}</span>
        <span>Position and Scale</span>
      </div>
      {open ? <PositionScaleDrawer {...props} /> : null}
    </div>
  );
}

function WorldLabelScaleInput(props) {
  const scale = getWorldLabelScale(props.scale);

  const handleCommit = (value) => {
    const nextScale = Number(value);
    if (isNaN(nextScale) || nextScale <= 0) {
      return;
    }

    Inventum.labels.scale(props.id, nextScale);
    props.getLabels();
  };

  return (
    <div className="StaticValueInputRow">
      <label
        className="StaticValueInputLabel"
        title="Label Size: Scale the world label in 3D without changing text size."
      >
        Label Size
      </label>
      <div className="StaticValueInputGroup">
        <CommitOnBlurNumberInput
          className="StaticValueInputField"
          wrapperClassName="InventumNumberInputControlFill"
          step={0.1}
          min={WORLD_LABEL_SCALE_MIN}
          value={scale}
          onCommit={handleCommit}
          onClick={(e) => e.stopPropagation()}
          title="Scale the world label in 3D without changing text size. Increase text size separately for sharper large labels."
        />
      </div>
    </div>
  );
}

function PositionScaleDrawer(props) {
  const style = props.style || {};
  const hasImage = Boolean(style.image);
  const imageScalePercent = Math.round(getWorldImageScale(style) * 100);
  const imagePosition = getWorldImagePosition(style);

  return (
    <div className="ScalePositionDrawerContainer">
      <div className="ScalePositionSection">
        <div className="ScalePositionSectionTitle">Scale</div>
        <div className="ScalePositionSectionContent">
          <WorldLabelScaleInput {...props} />
          {hasImage ? (
            <>
              <StaticValueInput
                title="Image Size"
                tooltip={`${WORLD_IMAGE_SCALE_DISPLAY_RANGE.min} - ${WORLD_IMAGE_SCALE_DISPLAY_RANGE.max}%. Bigger may clip.`}
                min={WORLD_IMAGE_SCALE_DISPLAY_RANGE.min}
                max={WORLD_IMAGE_SCALE_DISPLAY_RANGE.max}
                value={imageScalePercent}
                handleChange={(value) => {
                  Inventum.labels.setWorldLabelImageScale(props.id, value / 100);
                  props.getLabels();
                }}
              />
              <div className="StaticValueInputRow">
                <label className="StaticValueInputLabel" title="Image Position relative to the label text.">
                  Image Position
                </label>
                <div className="StaticValueInputGroup">
                  <div className="LabelSelectDropdownContainer">
                    <select
                      className="LabelTextDropdown LabelSelectDropdown"
                      value={imagePosition}
                      onChange={(event) => {
                        Inventum.labels.setWorldLabelImagePosition(props.id, event.target.value);
                        props.getLabels();
                      }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      {WORLD_IMAGE_POSITIONS.map((position) => (
                        <option key={position} value={position}>{position}</option>
                      ))}
                    </select>
                    <i className="material-icons notranslate LabelTextDropdownArrow LabelSelectDropdownArrow">
                      arrow_drop_down
                    </i>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="ScalePositionHelpText">
              Upload an image to adjust its size.
            </div>
          )}
        </div>
      </div>
      <div className="ScalePositionSection">
        <div className="ScalePositionSectionTitle">Position</div>
        <div className="ScalePositionSectionContent">
          <div className="ScalePositionHelpText">
            Use the Move Label button to reposition this world label in 3D.
          </div>
        </div>
      </div>
    </div>
  );
}

export { WorldLabelPositionScalePanel, getWorldImagePosition, getWorldImageScale, getWorldLabelScale };
